<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-scroll"></i></span>{{ 'StockSKUSearch.Header' | translate }}</h1>
  <p-card class="mx-2">
    <p-accordion [multiple]="true">
      <p-accordionTab
        header="{{
          'StockSKUSearch.SearchForm.Header' | translate
        }}"
        [(selected)]="isSearchFormOpen"
      >
        <ng-content *ngTemplateOutlet="settingSearchFormTemplate"></ng-content>
      </p-accordionTab>

      <p-accordionTab
        header="{{ 'StockSKUSearch.DataTable.OutboundDataTable.Header' | translate }}"
        [(selected)]="isOutboundDataTableOpen"
      >
        <ng-content *ngTemplateOutlet="settingOutboundDataTableTemplate"></ng-content>
      </p-accordionTab>

        <p-accordionTab
        header="{{ 'StockSKUSearch.DataTable.InventoryDataTable.Header' | translate }}"
        [(selected)]="isInventoryDataTableOpen"
      >
        <ng-content *ngTemplateOutlet="settingInventoryDataTableTemplate"></ng-content>
      </p-accordionTab>

        <p-accordionTab
        header="{{ 'StockSKUSearch.DataTable.InboundDataTable.Header' | translate }}"
        [(selected)]="isInboundDataTableOpen"
      >
        <ng-content *ngTemplateOutlet="settingInboundDataTableTemplate"></ng-content>
      </p-accordionTab>
    </p-accordion>
  </p-card>
</div>
<ng-template #settingSearchFormTemplate>
  <form [formGroup]="searchFormGroup">
    <div class="p-fluid formgrid grid">
      <div class="col-12 md:col-6 lg:col-3 mb-3">
        <label class="mb-2"><span class="requiredStart">*</span>{{ 'StockSKUSearch.SearchForm.Request.SKU' | translate }}</label>
        <input type="text" pInputText formControlName="sku"/>
      </div>
      <div class="col-12 md:col-6 lg:col-3 mb-3">
        <label class="mb-2"><span class="requiredStart">*</span>{{ 'StockSKUSearch.SearchForm.Request.HubPlantId' | translate }}</label>
       <laas-plant-dropdown
         [isSingle]="true"
         formControlName="hubPlantId">
       </laas-plant-dropdown>
     </div>
     <div class="col-12 md:col-6 lg:col-3 mb-3">
      <label class="mb-2"><span class="requiredStart">*</span>{{ 'StockSKUSearch.SearchForm.Request.Facility' | translate }}</label>
      <div class="item">
        <laas-facility-dropdown 
          formControlName="facility" 
          [isSingle]="true">
        </laas-facility-dropdown>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3 mb-3">
      <label class="mb-2"><span class="requiredStart">*</span>{{ 'StockSKUSearch.SearchForm.Request.Storer' | translate }}</label>
      <p-dropdown formControlName="storer"
        placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
        [options]="storerMappingOptions" dataKey="value" appendTo="body"></p-dropdown>
    </div>

    </div>
    <div>
      <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick()">
      </button>
    </div>
  </form>
</ng-template>

<ng-template #settingInventoryDataTableTemplate>
  <div class="mt-2">
    <laas-data-table
        #InventoryDataTable
        [value]="inventorySearchResults"
        [defaultColumns]="inventoryColumns"
        [loading]="isInventoryDataTableLoading"
        [paginator]="isInventoryDataTableOpenPage"
      >
		<ng-template pTemplate="body" let-rowData let-columns="columns">
			<td *ngFor="let col of columns">
				<ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>
				</ng-container>
			</td>
		</ng-template>
	  </laas-data-table>
  </div>
</ng-template>

<ng-template #settingInboundDataTableTemplate>
  <div class="mt-2">
    <laas-data-table
        #InboundDataTable
        [value]="inboundSearchResults"
        [defaultColumns]="inboundColumns"
        [loading]="isInboundDataTableLoading"
        [paginator]="isInboundDataTableOpenPage"
      >
		<ng-template pTemplate="body" let-rowData let-columns="columns">
			<td *ngFor="let col of columns">
				<ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'arriveDate'">
						<div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
						</div>
					</ng-container>
          <ng-container *ngSwitchCase="'receiptDocStatus'">
						<div class="overflow-text">
              {{ rowData[col.field] | optionsMapping: statusOptions | replaceNullWith:'-' }}
						</div>
					</ng-container>
          <ng-container *ngSwitchCase="'iqcFlag'">
						<div class="overflow-text">
              {{ rowData[col.field] | optionsMapping: IQCFlagOptions | replaceNullWith:'-' }}
						</div>
					</ng-container>
				</ng-container>
			</td>
		</ng-template>
	  </laas-data-table>
  </div>
</ng-template>

<ng-template #settingOutboundDataTableTemplate>
  <div class="mt-2">
    <laas-data-table
        #OutboundDataTable
        [value]="outboundSearchResults"
        [defaultColumns]="outboundColumns"
        [loading]="isOutboundDataTableLoading"
        [paginator]="isOutboundDataTableOpenPage"
      >
		<ng-template pTemplate="body" let-rowData let-columns="columns">
			<td *ngFor="let col of columns">
				<ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'orderDocStatus'">
						<div class="overflow-text">
              {{rowData[col.field] | optionsMapping: DOStatusOptions | replaceNullWith:'-' }}
						</div>
					</ng-container>
          <ng-container *ngSwitchCase="'etd'">
						<div class="overflow-text">
              {{rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
						</div>
					</ng-container>
				</ng-container>
			</td>
		</ng-template>
	  </laas-data-table>
  </div>
</ng-template>

<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
